import gql from 'graphql-tag'

// USED IN: UTIL
export const GetUserById = gql`
  query GetUserById($id: ID!, $onLogin: Boolean) {
    users(input: {
      ids: [$id],
      onLogin: $onLogin
    }) {
      results {
        id,
        enhancedReview,
        roles {
          type
        },
        person {
          firstName,
          middleName,
          lastName,
          prefix,
          suffix
        },
        specialties
        userType
      },
      launchDarklySdkId
    }
  }
`

export const SearchAltaisUser = gql`
  query SearchAltaisUser(
    $organizationId: ID!,
    $username: String,
    $email: String,
    $athenaPatientId: String,
    $athenaEncounterId: String
  ) {
    searchAltaisUser(input: {
      organizationId: $organizationId,
      username: $username,
      email: $email,
      athenaPatientId: $athenaPatientId,
      athenaEncounterId: $athenaEncounterId
    }) {
      providerId
      compositionId
      noteId
      patient {
        id
      }
      appointment {
        id
        emrId
        emrEncounterStatus
        emrDepartmentId
      }
    }
  }
`
